/**
 * Utils - Re-export all utilities for backward compatibility
 * Import from ./utils/ for organized, modular utilities
 */

export {
  TabsAutomatic,
  Dialog,
  throttle,
  onViewportEnter,
} from './utils/index.js';
